<template style="height: 100%;">
  <div class="xgsh">
    <div>
      <el-form style="padding: 20px; border-bottom: 2px solid #d7d7d7;padding-bottom: 0px" :inline="true"
        :model="formInline" class="demo-form-inline">
        <el-form-item label="综合查询">
          <el-input v-model="formInline.queryCondition" placeholder="姓名/身份证号/手机号/学号"></el-input>
        </el-form-item>
        <el-form-item label="单位" prop="DeptID">
          <div class="block">
            <el-cascader ref="wcascader" @change="Selected_to_shut_dow" @expand-change="bumen" v-model="DeptIDs"
              :options="data" :props="{ checkStrictly: true }" clearable
              :placeholder="$t('original.languages3')"></el-cascader>
          </div>
        </el-form-item>
        <el-form-item label="审批状态">
          <el-select v-model="formInline.status" placeholder="审批状态">
            <el-option label="待审批" value="0"></el-option>
            <el-option label="已同意" value="1"></el-option>
            <el-option label="已拒绝" value="2"></el-option>
            <el-option label="全部" value="9"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="修改内容">
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" label="全选"
            @change="handleCheckAllChangeSales"></el-checkbox>
          <el-checkbox @change="handleChec(aa1)" v-model="aa1" label="姓名"></el-checkbox>
          <el-checkbox @change="handleChec(aa2)" v-model="aa2" label="学号"></el-checkbox>
          <el-checkbox @change="handleChec(aa3)" v-model="aa3" label="所在单位"></el-checkbox>
          <el-checkbox @change="handleChec(aa4)" v-model="aa4" label="身份证号"></el-checkbox>
          <el-checkbox @change="handleChec(aa5)" v-model="aa5" label="手机号"></el-checkbox>
          <el-checkbox @change="handleChec(aa6)" v-model="aa6" label="邮箱地址"></el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-button style="background-color: rgb(221 172 0 / 84%);border: 1px solid rgb(221 172 0 / 84%);" type="primary"
            @click="onSubmit">查询</el-button>
          <el-button style="" type="primary" @click="resets()">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <div style="padding-top: 10px;margin-left: 10px;">
        <el-button type="primary" @click="Selective_consent()" :loading="selagreeload">选中同意</el-button>
        <el-button style="background-color: #f76969;border:1px solid #f76969;" type="primary"
          @click="Selective_refuse()" :loading="selreferload">选中拒绝</el-button>

        <el-popconfirm title="确定全部同意吗？" @confirm="resetSubmitForm">
          <el-button
            style="background-color: rgba(21, 191, 109, 1);border: 1px solid rgba(21, 191, 109, 1);margin-left: 10px;margin-right: 10px;"
            type="primary" slot="reference" :loading="allagreeload">全部同意</el-button>
        </el-popconfirm>

        <el-popconfirm title="确定全部拒绝吗？" @confirm="resetSubmitForm2">
          <el-button style="background-color: red;border: 1px solid red;margin-right: 10px;" type="primary"
            slot="reference" :loading="allreferload">全部拒绝</el-button>
        </el-popconfirm>
      </div>

      <el-table ref="multipleTable" v-loading="wloadings" @selection-change="handleSelectionChange"
        :row-key="(row) => { return row.PaperResultID; }" :data="tableData" style="width: 100%; margin-top: 10px"
        :default-sort="{ prop: 'date', order: 'descending' }">

        <el-table-column type="selection" :selectable="checkSelectable" width="55"></el-table-column>

        <el-table-column label="姓名">
          <template slot-scope="scope">
            <span v-if="scope.row.realNameStatus == 1" style="color: rgb(0, 136, 255);">{{ scope.row.realName }}</span>
            <span v-else>{{ scope.row.realName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="学号">
          <template slot-scope="scope">
            <span v-if="scope.row.userIDStatus == 1" style="color: rgb(0, 136, 255);">{{ scope.row.userID }}</span>
            <span v-else>{{ scope.row.userID }}</span>
          </template>
        </el-table-column>
        <el-table-column label="培养单位">
          <template slot-scope="scope">
            <span v-if="scope.row.deptIDStatus == 1" style="color: rgb(0, 136, 255);">{{ scope.row.deptName }}</span>
            <span v-else>{{ scope.row.deptName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="身份证号">
          <template slot-scope="scope">
            <span v-if="scope.row.idcardStatus == 1" style="color: rgb(0, 136, 255);">{{ scope.row.idcard }}</span>
            <span v-else>{{ scope.row.idcard }}</span>
          </template>
        </el-table-column>

        <el-table-column label="手机号" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.phoneStatus == 1" style="color: rgb(0, 136, 255);">{{ scope.row.phone }}</span>
            <span v-else>{{ scope.row.phone }}</span>
          </template>
        </el-table-column>

        <el-table-column label="邮箱">
          <template slot-scope="scope">
            <span v-if="scope.row.emailStatus == 1" style="color: rgb(0, 136, 255);">{{ scope.row.email }}</span>
            <span v-else>{{ scope.row.email }}</span>
          </template>
        </el-table-column>

        <el-table-column label="提交时间">
          <template slot-scope="scope">
            <span>{{ scope.row.createdDateStr }}</span>
          </template>
        </el-table-column>

        <el-table-column label="状态" width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0"
              style="color: #fff;background-color: rgba(0, 136, 255, 1);padding: 8px;border-radius: 12px;">待审批</span>
            <span v-else-if="scope.row.status == 1"
              style="color: #fff; background-color: rgba(21, 191, 109, 1);padding: 8px;border-radius: 12px;">已同意</span>
            <span v-else
              style="color: #fff;background-color: rgba(242, 75, 78, 1);padding: 8px;border-radius: 12px;">已拒绝</span>
          </template>
        </el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <span style="cursor:pointer;color: #409EFF;padding: 5px;" @click="looks(scope)">查看</span>
            <span v-if="scope.row.status == 0" style="cursor:pointer;color: rgba(21,191,109,1);padding: 5px;"
              @click="arrgee(scope)">同意</span>
            <span v-if="scope.row.status == 0" style="cursor:pointer;color: rgba(214,11,34,1);padding: 5px;"
              @click="refuse(scope)">拒绝</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top: 10px;margin-right: 20px;" @current-change="handleCurrentChange"
        :current-page.sync="currentPage1" :page-size="10" layout="total,prev,pager,next,jumper" :total="Counts">
      </el-pagination>
    </div>
    <el-dialog :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
      <ul class="tsk">
        <li>
          <h2>修改前</h2>
          <div>

            <p v-if="excessive.realNameStatus == 1">
              <span>姓名：</span>
              <span style="color: rgb(0, 136, 255);">
                {{ excessive.realName }}
              </span>
            </p>
            <p v-else><span>姓名：</span>{{ excessive.realName }}</p>

            <p v-if="excessive.userIDStatus == 1">
              <span>学号：</span>
              <span style="color: rgb(0, 136, 255);">
                {{ excessive.userID }}
              </span>


            </p>
            <p v-else><span>学号：</span>{{ excessive.userID }}</p>

            <p v-if="excessive.deptIDStatus == 1">
              <span>培养单位：</span>
              <span style="color: rgb(0, 136, 255);">
                {{ excessive.deptID + excessive.deptName }}
              </span>
            </p>
            <p v-else><span>培养单位：</span>{{ excessive.deptID + excessive.deptName }}</p>

            <p v-if="excessive.idcardStatus == 1">
              <span>身份证号：</span>
              <span style="color: rgb(0, 136, 255);">
                {{ excessive.idcard }}
              </span>
            </p>
            <p v-else><span>身份证号：</span>{{ excessive.idcard }}</p>

            <p v-if="excessive.phoneStatus == 1">
              <span>手机号：</span>
              <span style="color: rgb(0, 136, 255);">
                {{ excessive.phone }}
              </span>
            </p>
            <p v-else><span>手机号：</span>{{ excessive.phone }}</p>

            <p v-if="excessive.emailStatus == 1">
              <span>邮箱地址：</span>
              <span style="color: rgb(0, 136, 255);">
                {{ excessive.email }}
              </span>

            </p>
            <p v-else><span>邮箱地址：</span>{{ excessive.email }}</p>

          </div>
        </li>
        <li>
          <h2>修改后</h2>
          <div>

            <p v-if="excessive.realNameStatus == 1">
              <span>姓名：</span>
              <span style="color: rgb(0, 136, 255);">
                {{ excessive.realName2 ? excessive.realName2 : excessive.realName }}
              </span>
            </p>
            <p v-else><span>姓名：</span>{{ excessive.realName2 ? excessive.realName2 : excessive.realName }}</p>

            <p v-if="excessive.userIDStatus == 1">
              <span>学号：</span>
              <span style="color: rgb(0, 136, 255);">
                {{ excessive.userID2 ? excessive.userID2 : excessive.userID }}
              </span>
            </p>
            <p v-else><span>学号：</span>{{ excessive.userID2 ? excessive.userID2 : excessive.userID }}</p>

            <p v-if="excessive.deptIDStatus == 1">
              <span>培养单位：</span>
              <span style="color: rgb(0, 136, 255);">
                {{ excessive.deptID2 + excessive.deptName2 }}
              </span>

            </p>
            <p v-else><span>培养单位：</span>{{ excessive.deptID2 + excessive.deptName2 }}</p>

            <p v-if="excessive.idcardStatus == 1">
              <span>身份证号：</span>
              <span style="color: rgb(0, 136, 255);">
                {{ excessive.idcard2 ? excessive.idcard2 : excessive.idcard }}
              </span>
            </p>
            <p v-else><span>身份证号：</span>{{ excessive.idcard2 ? excessive.idcard2 : excessive.idcard }}</p>
            <p v-if="excessive.phoneStatus == 1">
              <span>手机号：</span>
              <span style="color: rgb(0, 136, 255);">
                {{ excessive.phone2 ? excessive.phone2 : excessive.phone }}
              </span>
            </p>
            <p v-else><span>手机号：</span>{{ excessive.phone2 ? excessive.phone2 : excessive.phone }}</p>
            <p v-if="excessive.emailStatus == 1">
              <span>邮箱地址：</span>
              <span style="color: rgb(0, 136, 255);">
                {{ excessive.email2 ? excessive.email2 : excessive.email }}
              </span>
            </p>
            <p v-else><span>邮箱地址：</span>{{ excessive.email2 ? excessive.email2 : excessive.email }}</p>
          </div>
        </li>
      </ul>

      <el-button class="argee" v-if="dis" @click="arrgee2()" type="primary" style="margin-left: 25%;color: rgba(21,191,109,1);border: 1px solid rgba(21,191,109,1);background-color: #fff;" :loading="agreeload">同意</el-button>

      <el-button v-if="dis" @click="refuses()" type="primary" style="margin-left: 10%;color: red;border: 1px solid red;background-color: #fff;" :loading="referload">拒绝</el-button>
      
      <el-button v-if="dis" @click="Closes()" type="primary" style="margin-left: 10%;">返回</el-button>

      <el-button v-if="!dis" @click="Closes()" type="primary" style="margin-left: 43%;">返回</el-button>

    </el-dialog>
  </div>
</template>
<script>

export default {
  data() {
    return {
      chongzhiDeptID: '',
      DeptIDs: '',
      formInlines: {},//全部搜过度数据
      isIndeterminate: false,
      checkAll: false,
      isALL: false, //全选框是否在勾选状态
      bushForm: [],
      dis: true,
      excessive: '',//带年纪查看过度数据
      dialogVisible: false,
      aa1: false,
      aa2: false,
      aa3: false,
      aa4: false,
      aa5: false,
      aa6: false,
      pageIndex: 1,
      Counts: 0,
      currentPage1: 1,
      data: [],
      wloadings: true,
      tableData: [],
      formInline: {
        queryCondition: '',
        userID: '',
        DeptID: '',
        realName: '',
        phone: '',
        email: '',
        updateInfo: [0, 0, 0, 0, 0, 0],
        idCard: '',
        status: '0',
      },
      KeyNos: [],
      UserIDs: [],
      UserID2s: [],
      allagreeload:false,
      allreferload:false,
      selagreeload:false,
      selreferload:false,
      agreeload:false,
      referload:false,
    };
  },
  mounted: function () {
    this.$Http_Post('/DepartMent/GetDeprtMentByNode', { DeptID: '', content: '' }).then((res) => {
      if (res.Code == 200 || res.Code == 0 && res.Data) {
        this.data = res.Data;
        this.DeptIDs = res.Data[0].DeptID;
        this.chongzhiDeptID = res.Data[0].DeptID;
      }
    })
    this.loading();
  },
  created() {

  },
  methods: {
    checkSelectable(row, index) {
      if (row.status == 0) {
        return true;
      } else {
        return false;
      }
    },
    Closes() {
      this.dialogVisible = false;
    },
    handleChec() {
      if (this.aa1 && this.aa2 && this.aa3 && this.aa4 && this.aa5 && this.aa6) {
        this.isIndeterminate = false;
        this.checkAll = true;
      } else if (!this.aa1 && !this.aa2 && !this.aa3 && !this.aa4 && !this.aa5 && !this.aa6) {
        this.isIndeterminate = false;
        this.checkAll = false;
      } else {
        this.isIndeterminate = true;
        this.checkAll = false;
      }
    },
    handleCheckAllChangeSales(val) {
      this.aa1 = true;
      if (val) {
        this.aa1 = true;
        this.aa2 = true;
        this.aa3 = true;
        this.aa4 = true;
        this.aa5 = true;
        this.aa6 = true;
        this.isIndeterminate = false;
        this.checkAll = true;
      } else {
        this.aa1 = false;
        this.aa2 = false;
        this.aa3 = false;
        this.aa4 = false;
        this.aa5 = false;
        this.aa6 = false;
        this.isIndeterminate = false;
        this.checkAll = false;
      }
    },
    resets() {
      this.formInline = {
        queryCondition: '',
        userID: '',
        DeptID: '',
        realName: '',
        phone: '',
        email: '',
        updateInfo: [false, false, false, false, false, false],
        idCard: '',
        status: '0',
      }
      this.aa1 = false,
        this.aa2 = false,
        this.aa3 = false,
        this.aa4 = false,
        this.aa5 = false,
        this.aa6 = false,
        this.isIndeterminate = false,
        this.checkAll = false,
        this.DeptIDs = this.chongzhiDeptID;
      this.loading();
    },
    timeFormatSeconds(time) {
      var d = time ? new Date(time) : new Date();
      var year = d.getFullYear();
      var month = d.getMonth() + 1;
      var day = d.getDate();
      var hours = d.getHours();
      var min = d.getMinutes();
      var seconds = d.getSeconds();
      if (month < 10) month = '0' + month;
      if (day < 10) day = '0' + day;
      if (hours < 0) hours = '0' + hours;
      if (min < 10) min = '0' + min;
      if (seconds < 10) seconds = '0' + seconds;
      return (year + '-' + month + '-' + day);
    },
    resetSubmitForm() {
      this.allagreeload=true;
      this.$Http_Post("Activation/AgreeActivationUserAll", { "deptID": this.formInlines.DeptID, "realName": this.formInlines.realName, "updateInfo": this.formInlines.updateInfo, "queryCondition": this.formInlines.queryCondition, "status": this.formInline.status }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.loading();
        } else {
          this.Global.request_failure(res.Message);
        }
        this.allagreeload=false;
      })
    },
    resetSubmitForm2() {
      this.allreferload=true;
      this.$Http_Post("Activation/RejectActivationUserAll", { "deptID": this.formInlines.DeptID, "realName": this.formInlines.realName, "updateInfo": this.formInlines.updateInfo, "queryCondition": this.formInlines.queryCondition, "status": this.formInline.status }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.loading();
        } else {
          this.Global.request_failure(res.Message);
        }
        this.allreferload=false;
      })
    },
    refuse(val) {
      var keyNo = [];
      var UserIDs = [];
      var UserID2s = [];
      keyNo.push(val.row.keyNo);
      UserIDs.push(val.row.userID);
      UserID2s.push(val.row.userID2);
      this.$Http_Post("Activation/RejectActivationUser", { "KeyNos": keyNo, "UserIDs": UserIDs, "UserID2s": UserID2s }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.loading();
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    refuses() {//驳回
      var keyNo = [];
      var UserIDs = [];
      var UserID2s = [];
      keyNo.push(this.excessive.keyNo);
      UserIDs.push(this.excessive.userID);
      UserID2s.push(this.excessive.userID2);
      this.referload=true;
      this.$Http_Post("Activation/RejectActivationUser", { 
        "KeyNos": keyNo, 
        "UserIDs": UserIDs, 
        "UserID2s": UserID2s,
        "deptID": this.formInline.DeptID,
        "status": this.formInline.status
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.excessive = res.Data;
          keyNo = [];
          UserIDs = [];
          UserID2s = [];
          keyNo.push(res.Data.keyNo);
          UserIDs.push(res.Data.UserIDs);
          UserID2s.push(res.Data.UserID2s);

          this.loading();
        } else {
          this.Global.request_failure(res.Message);
        }
        this.referload=false;
      })
    },
    arrgee(val) {
      var keyNo = [];
      var UserIDs = [];
      var UserID2s = [];
      keyNo.push(val.row.keyNo);
      UserIDs.push(val.row.userID);
      UserID2s.push(val.row.userID2);
      this.$Http_Post("Activation/AgreeActivationUser", { 
        "KeyNos": keyNo, 
        "UserIDs": UserIDs, 
        "UserID2s": UserID2s,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.loading();
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    arrgee2() {//同意
      var keyNo = [];
      var UserIDs = [];
      var UserID2s = [];
      keyNo.push(this.excessive.keyNo);
      UserIDs.push(this.excessive.userID);
      UserID2s.push(this.excessive.userID2);
      this.agreeload=true;
      this.$Http_Post("Activation/AgreeActivationUser", { 
        "KeyNos": keyNo, 
        "UserIDs": UserIDs, 
        "UserID2s": UserID2s,
        "deptID": this.formInline.DeptID,
        "status": this.formInline.status
       }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.excessive = res.Data;
          keyNo = [];
          UserIDs = [];
          UserID2s = [];
          keyNo.push(res.Data.keyNo);
          UserIDs.push(res.Data.UserIDs);
          UserID2s.push(res.Data.UserID2s);
          this.loading();
          // this.dialogVisible = false;
        } else {
          this.Global.request_failure(res.Message);
        }
        this.agreeload=false;
      })
    },
    Selective_consent() {
      if (this.KeyNos.length <= 0) {
        this.Global.request_failure("请选择需要同意的项！");
      } else {
        this.selagreeload=true;
        this.$Http_Post("Activation/AgreeActivationUser", { "KeyNos": this.KeyNos, "UserIDs": this.UserIDs, "UserID2s": this.UserID2s }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.Global.request_successful(res.Message);
            this.loading();
          } else {
            this.Global.request_failure(res.Message);
          }
          this.selagreeload=false;
        })
      }
    },
    Selective_refuse() {
      if (this.KeyNos.length <= 0) {
        this.Global.request_failure("请选择需要拒绝的项！");
      } else {
        this.selreferload=true;
        this.$Http_Post("Activation/RejectActivationUser", { "KeyNos": this.KeyNos, "UserIDs": this.UserIDs, "UserID2s": this.UserID2s }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.Global.request_successful(res.Message);
            this.loading();
          } else {
            this.Global.request_failure(res.Message);
          }
          this.selreferload=false;
        })
      }
    },
    looks(val) {
      this.dialogVisible = true;
      this.excessive = val.row;
      if (val.row.status == 0) {
        this.dis = true;
      } else {
        this.dis = false;
      }
    },
    handleClose(done) {
      this.$confirm('确认关闭？').then(_ => {
        done();
      })
      .catch(_ => { });
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.loading();
    },
    loading() {
      this.$Http_Post("Activation/QueryActivationUserList", { "deptID": this.formInline.DeptID, "realName": this.formInline.realName, "updateInfo": this.formInline.updateInfo, "queryCondition": this.formInline.queryCondition, "pageIndex": this.pageIndex, "pageSize": 10, "status": this.formInline.status }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.tableData = res.Data;
          this.Counts = Number(res.Counts);
          this.wloadings = false;
        } else {
          this.wloadings = false;
        }
      })
    },
    handleSelectionChange(val) {
      var lsc1 = [];
      var lsc2 = [];
      var lsc3 = [];
      for (var i = 0; i < val.length; i++) {
        lsc1.push(val[i].keyNo);
        lsc2.push(val[i].userID);
        lsc3.push(val[i].userID2);
      }
      this.KeyNos = lsc1;
      this.UserIDs = lsc2;
      this.UserID2s = lsc3;
    },
    onSubmit() {
      this.pageIndex = 1;
      this.formInline.updateInfo = [];
      this.formInline.updateInfo.push(this.aa1 ? 1 : 0);
      this.formInline.updateInfo.push(this.aa2 ? 1 : 0);
      this.formInline.updateInfo.push(this.aa3 ? 1 : 0);
      this.formInline.updateInfo.push(this.aa4 ? 1 : 0);
      this.formInline.updateInfo.push(this.aa5 ? 1 : 0);
      this.formInline.updateInfo.push(this.aa6 ? 1 : 0);
      this.loading();
      this.formInlines = this.formInline;
    },
    Selected_to_shut_dow(dt) {
      this.formInline.DeptID = dt[dt.length - 1];
      this.$refs.wcascader.dropDownVisible = false;
    },
    GetNodeByDeptID(ID, NodeList) {
      let obj = null;
      for (let i = 0; i < NodeList.length; i++) {
        if (NodeList[i].DeptID == ID) {
          obj = NodeList[i];
          break
        } else if (NodeList[i].fuzi && NodeList[i].children.length > 0 && NodeList[i].children[0].DeptID != '-1') {
          obj = this.GetNodeByDeptID(ID, NodeList[i].children);
          if (obj != null) break
        }
      }
      return obj;
    },
    bumen(dt) {
      let obj = this.data[0];
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i].DeptID == dt[dt.length - 1]) {
          obj = this.data[i];
        } else if (this.data[i].fuzi && this.data[i].children.length > 0 && this.data[i].children[0].DeptID != '-1') {
          obj = this.GetNodeByDeptID(dt[dt.length - 1], this.data[i].children);
        }
      }
      if (obj.fuzi && obj.children.length > 0 && obj.children[0].DeptID == '-1') {
        obj.children = [{ label: this.$t('original.languages22') }];
        this.$Http_Post('/DepartMent/GetDeprtMentByNode', { DeptID: dt[dt.length - 1], content: '' }).then((res) => {
          if (res.Code == 200 || res.Code == 0 && res.Data) {
            obj.children = res.Data;
          }
        })
      }
    },
  },
};
</script>
<style>
.xgsh {
  height: 100%;
  overflow: auto;
  background-color: #fff;
}

.xgsh .tsk {
  height: 370px;
}

.xgsh .tsk li {
  width: 40%;
  float: left;
  margin-left: 5%;
}

.xgsh .tsk li div {
  background-color: #fff;
  margin-top: 20px;
  height: 300px;
}

.xgsh .tsk li div p {
  padding: 15px;
}

.xgsh .el-table--enable-row-transition .el-table__body td {
  text-align: center;
}

.xgsh .el-dialog__wrapper {
  background-color: rgba(245, 247, 250, 1);
}

.xgsh .el-dialog {
  box-shadow: none
}

.xgsh .el-dialog {
  background: rgba(245, 247, 250, 1);
}

.xgsh .el-dialog__headerbtn {
  position: fixed;
  top: 30px;
  right: 20px;
  font-size: 30px;
}
</style>
